'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'How Create Electronic Signature SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'How Do I Create An Electronic Signature?',
            subtitle: 'Ready to jump in and start signing?',
            buttonText: 'CREATE YOUR FREE ACCOUNT'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How do I create an electronic signature?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can create your electronic signature in a few different ways. Each signature takes only a few clicks or swipes and will be stored in your HelloSign account for future signing. Here are your options:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Draw your signature using your finger or a stylus.'
                    ),
                    ' If you have access to a touchscreen, you can use your finger to create an electronic signature directly in your document. This is particularly helpful for when you\u2019re signing on a mobile device or tablet!'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Upload an image of your signature.'
                    ),
                    ' Use your phone or camera to take a picture of your paper signature. Once it\u2019s uploaded into your HelloSign account, it will be turned into a .png file that overlays neatly over the signature line in your document.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Use your cursor to draw your signature.'
                    ),
                    ' Using your mouse or your touchpad, you can drag your cursor along the signature line to create a unique electronic signature.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Use your keyboard to type in your signature.'
                    ),
                    ' This is the easiest way to create your electronic signature. Once you\u2019ve typed in your name, you can select a font that best matches your paper signature.'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Is an electronic signature as legal as a paper signature?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Yes! Electronic signatures are federally protected by the ESIGN Act of 2000. They\u2019re also protected on a statewide basis by the UETA Act. Internationally, eSignatures are protected by various acts and legislations. We have customers using HelloSign in Australia, the EU, and more!'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Is it secure to use electronic signatures to sign documents?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Yep! It\u2019s absolutely secure as long as you\u2019re working with a verified and secure eSignature provider. HelloSign offers bank-level security to ensure that your information and documents remain protected. This includes:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Hosting in a state-of-the-art SAS70 Type II, SSAE 16 facility that has achieved ISO 27001 certification.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'A connection that\u2019s encrypted using SSL (Secure Sockets Layer). That\u2019s the same level of security at most leading banks!'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Documents are stored and encrypted at rest using AES - 256 bit encryption.'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Do I have to electronically sign documents in my HelloSign account?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign integrates with several other companies to make it as easy as possible to sign in whatever app you\u2019re using. Our integration partners include:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Google (including ',
                    _react2['default'].createElement(
                        'a',
                        { href: 'https://www.hellosign.com/gmail',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Gmail'
                    ),
                    ', ',
                    _react2['default'].createElement(
                        'a',
                        { href: 'https://www.hellosign.com/googledrive',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Google Drive'
                    ),
                    ', and ',
                    _react2['default'].createElement(
                        'a',
                        {
                            href: 'https://www.hellosign.com/google-docs-add-on', target: '_blank', rel: 'noopener noreferrer' },
                        'Google Docs'
                    ),
                    ')'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Evernote'
                    )
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/dropbox/', target: '_blank', rel: 'noopener noreferrer' },
                        'Dropbox'
                    )
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Slack'
                    )
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Zapier'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'HubSpot CRM'
                    )
                )
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You may be directed to our site to complete the signature, but you can initiate signature requests directly in the integrated apps.'
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Create an Electronic Signature',
            subtitle: 'See it for yourself! Create your first electronic signature by opening a HelloSign account. You’ll get three signatures a month with our free plan and unlimited signatures with any Pro plan or above.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/how-create-electronic-signature.jsx
 ** module id = 1222
 ** module chunks = 0
 **/